import React from 'react'

import type { IconProps } from './types'

const BabyGrowth: React.FC<IconProps> = ({
  size = 24,
  color = '#595959',
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M20.187 8.668c-1.055-2.911-3.681-5.032-6.748-5.546a.6.6 0 0 0-.168-.036l-.118-.003A9 9 0 0 0 12 3C8.335 3 5.03 5.31 3.812 8.668A2.85 2.85 0 0 0 1 11.514a2.85 2.85 0 0 0 2.812 2.845C5.03 17.716 8.335 20.027 12 20.027a8.8 8.8 0 0 0 4.012-.98 7 7 0 0 1-.79-.8 7.7 7.7 0 0 1-3.222.716c-3.346 0-6.35-2.188-7.305-5.32l-.134-.438-.453.068a2 2 0 0 1-.262.021 1.783 1.783 0 0 1-1.782-1.781 1.784 1.784 0 0 1 2.045-1.76l.453.067.133-.438c.648-2.123 2.238-3.81 4.237-4.677-.446.989.16 2.207 1.17 2.682 1.258.593 3.295.67 4.153-.618.388-.581.044-1.315-.424-1.712-.656-.557-1.608-.636-2.387-.327-.63.25-.356 1.28.283 1.027.463-.183.884-.197 1.329.047.61.335.048.717-.378.84-.794.228-1.965.042-2.586-.515-.783-.704.226-1.502.85-1.72.677-.238 1.421-.29 2.137-.264 2.897.412 5.375 2.448 6.225 5.237l.134.439.453-.067c.102-.015.186-.022.263-.022.983 0 1.782.8 1.782 1.782s-.8 1.781-1.782 1.781c-.077 0-.16-.007-.262-.022l-.454-.068-.134.44a7 7 0 0 1-.161.458 2.18 2.18 0 0 1 1.55.204A2.85 2.85 0 0 0 23 11.514a2.85 2.85 0 0 0-2.813-2.846"
        fill={color}
      />
      <path
        d="M9.752 11.144c-.915 0-.915 1.419 0 1.419s.915-1.42 0-1.42m4.495-.088c-.915 0-.915 1.42 0 1.42.915-.001.915-1.42 0-1.42M12 16.126a2.095 2.095 0 0 0 2.093-2.093.532.532 0 1 0-1.065 0 1.03 1.03 0 0 1-2.057 0 .532.532 0 1 0-1.064 0c0 1.154.939 2.093 2.093 2.093m6.114-1.115c-2.146-1.231-5.088 2.22 0 4.829 5.142-2.638 2.08-6.021 0-4.829m0 3.621c-2.541-1.507-1.83-2.805-.935-2.805.418 0 .624.282.935.577.311-.295.518-.577.936-.577.788 0 1.71 1.232-.936 2.805"
        fill={color}
      />
    </svg>
  )
}

export default BabyGrowth
